import { render, staticRenderFns } from "./Juizo.vue?vue&type=template&id=bbe01fc0&"
import script from "./Juizo.vue?vue&type=script&lang=js&"
export * from "./Juizo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports